import { UserInfo } from "../../models";

import { AuthScope } from "../scopes";
import { createAction } from "./internal/platformActionCreators";

export enum AuthActions {
  CHECK_AUTH_STATUS = "@auth/CHECK_AUTH_STATUS",
  UPDATE_USER = "@auth/UPDATE_USER",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authActions = {
  checkAuthStatus: createAction(
    AuthActions.CHECK_AUTH_STATUS,
    AuthScope,
    (initialClientSetup: boolean | undefined) => ({ initialClientSetup })
  ),
  updateUser: createAction(
    AuthActions.UPDATE_USER,
    AuthScope,
    (userInfo: UserInfo | undefined) => ({
      userInfo,
    })
  ),
};
